import React from 'react';
import { Search, Target, Users, Handshake, ClipboardCheck, TrendingUp } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import SectionHeading from '@/components/site/SectionHeading';

const STEPS = [
  { icon: Search, title: 'Property Assessment', desc: 'Asset audit, condition review, and benchmarking against comparable Hyderabad inventory.' },
  { icon: Target, title: 'Market Positioning', desc: 'Branding, marketing collateral, and rental pricing strategy aligned to target tenant profile.' },
  { icon: Users, title: 'Tenant Acquisition', desc: 'Outreach to qualified occupiers and broker network; coordinated site visits.' },
  { icon: Handshake, title: 'Lease Negotiation', desc: 'Commercial and legal negotiation, MoU, and registered lease execution.' },
  { icon: ClipboardCheck, title: 'Property Management', desc: 'Operations, vendor management, tenant relationships, and CapEx planning.' },
  { icon: TrendingUp, title: 'Performance Optimization', desc: 'Quarterly asset reviews, escalation planning, and ongoing yield enhancement.' },
];

export default function Process() {
  return (
    <section data-testid="home-process" className="py-20 md:py-28 bg-[#144726] text-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C6A35B]">Our process</p>
            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">A six-step framework, repeated with discipline.</h2>
            <p className="mt-4 text-base md:text-lg leading-relaxed text-white/70">From the first asset audit to ongoing performance optimization, our process is structured, measurable, and repeatable across every mandate we take on.</p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 80}>
              <div className="relative h-full rounded-xl border border-white/10 bg-white/[0.04] p-7 hover:bg-white/[0.07] transition-colors">
                <p className="font-display text-5xl font-semibold text-[#C6A35B]/30">0{i + 1}</p>
                <div className="mt-4 flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#C6A35B] text-[#144726]"><s.icon className="h-5 w-5" /></div>
                  <h3 className="text-lg font-semibold">{s.title}</h3>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-white/70">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
